import React from "react";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import TableContainer from "../../../Common/Table/TableContainer";
import TableCell from "../../../Common/Table/TableCell";
import { generalCategories } from "../../../../utils/categories";
import { useSelectorApp } from "../../../../lib/redux";
import { validateIsValidDate } from "../../../../utils/dates";
import { useTranslationApp } from "../../../../lib/i18next";
import InfoIcon from "@mui/icons-material/Info";
import {
  COLUMN_NAME_BRAND,
  COLUMN_NAME_CATEGORY,
  COLUMN_NAME_COUNTRY,
  COLUMN_NAME_DATE,
  COLUMN_NAME_EMAIL,
  COLUMN_NAME_IS_ACTIVE,
  COLUMN_NAME_NAME,
  COLUMN_NAME_PHONE,
  COLUMN_NAME_WEB_SITE,
  DATE_SHORT,
  NO,
  SHOPS_ACCEPTED_TABLE_ARIA_LABEL,
  YES,
} from "../../../../locales/keysTranslations";
import LinkText from "../../../Common/Texts/LinkText";

const ShopsAcceptedTable = ({
  data,
  page,
  onPageChange,
  rowsPerPage,
  signUpCountry,
  filter,
  onChangeShopSelected,
}) => {
  const locales = useSelectorApp((state) => state?.locales?.localesList) || {};
  const shops = useSelectorApp((state) => state.shop.shops);

  const { t } = useTranslationApp();

  const keys = Object.keys(data);

  const keysSorted = keys.sort((a, b) => {
    const dateA = data[a].creationTime;
    const dateB = data[b].creationTime;
    if (!dateA && !dateB) return 0;
    return dateB - dateA;
  });
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <TableContainer
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        keys={keys}
        loading={false}
        ariaLabel={t(SHOPS_ACCEPTED_TABLE_ARIA_LABEL)}
        sx={{ overflow: "auto" }}
      >
        <TableHead>
          <TableRow>
            <TableCell align="center" isHeader={true}>
              {t(COLUMN_NAME_COUNTRY)}
            </TableCell>
            <TableCell align="center" isHeader={true}>
              {t(COLUMN_NAME_BRAND)}
            </TableCell>
            <TableCell align="center" isHeader={true}>
              {t(COLUMN_NAME_CATEGORY)}
            </TableCell>
            <TableCell align="center" isHeader={true}>
              {t(COLUMN_NAME_IS_ACTIVE)}
            </TableCell>
            <TableCell align="center" isHeader={true}>
              {t(COLUMN_NAME_WEB_SITE)}
            </TableCell>
            <TableCell align="center" isHeader={true}>
              {t(COLUMN_NAME_EMAIL)}
            </TableCell>
            <TableCell align="center" isHeader={true}>
              {t(COLUMN_NAME_NAME)}
            </TableCell>
            <TableCell align="center" isHeader={true}>
              {t(COLUMN_NAME_PHONE)}
            </TableCell>
            <TableCell align="center" isHeader={true}>
              {t(COLUMN_NAME_DATE)}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? keysSorted.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
            : keysSorted
          ).map((row, index) => {
            const info = data[row];
            const shop = shops[info.shopID] || {};
            const country = locales[info.signUpCountry] || {};

            if (filter === "isLogged" && !shop.isLoggedFirstTime) return null;
            if (filter === "isNotLogged" && shop.isLoggedFirstTime) return null;
            if (filter === "planRegular" && info.plan !== "regular")
              return null;
            if (filter === "planEnterprise" && info.plan !== "enterprise")
              return null;

            return (
              <TableRow key={index}>
                <TableCell align="center" indexRow={index}>
                  {country?.name || "-"}
                </TableCell>
                <TableCell align="center" indexRow={index}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <LinkText
                      href={`/shop?shopID=${info.shopID}`}
                      target="_blank"
                    >
                      {shop?.businessName ?? "-"}
                    </LinkText>
                    <IconButton
                      onClick={() => onChangeShopSelected(row)}
                      color="primary"
                    >
                      <InfoIcon />
                    </IconButton>
                  </Box>
                </TableCell>
                <TableCell align="center" indexRow={index}>
                  {t(
                    generalCategories.find(
                      (cat) => cat.value === info?.category
                    ).label
                  ) ?? "-"}
                </TableCell>
                <TableCell align="center" indexRow={index}>
                  {shop?.isActiveFirstTime && shop?.isPlanActive
                    ? t(YES)
                    : t(NO)}
                </TableCell>
                <TableCell
                  align="center"
                  indexRow={index}
                  sx={{ minWidth: 230 }}
                >
                  {info?.webSite ? (
                    <LinkText
                      href={info?.webSite}
                      target="_blank"
                      sx={{ wordBreak: "break-all" }}
                    >
                      {info?.webSite}
                    </LinkText>
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell align="center" indexRow={index}>
                  {info?.email ?? "-"}
                </TableCell>
                <TableCell align="center" indexRow={index}>
                  {info?.name ?? "-"}
                </TableCell>
                <TableCell align="center" indexRow={index}>
                  {info?.phone ?? "-"}
                </TableCell>
                <TableCell align="center" indexRow={index}>
                  {validateIsValidDate(shop.creationTime) &&
                    t(DATE_SHORT, {
                      date: new Date(shop.creationTime),
                    })}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </TableContainer>
    </Box>
  );
};

export default ShopsAcceptedTable;
